import React, { useState, useRef, useEffect } from "react";
import { Table } from "antd";
import { Icon } from "@iconify/react";
import DelTableRowModal from "../../modals/delTableRowModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import RatingModal from "../../modals/RatingModal";
import { useTranslation } from "react-i18next";
import { getAllFeedback } from "../../APIs/feedbackApis";
import { extractDateFromISO } from "../../utils/helpers";

const RatingandReviews = () => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const datePickerRef = useRef(null);
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  const [isfeedbackOpen, setisfeedbackOpen] = useState(false);
  const [feedbackData, setFeedbackData] = useState();
  const [record, setRecord] = useState(null);
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const onDelClick = () => {
    setIsdelModalOpen(true);
  };
  const onviewClick = (record) => {
    console.log(record);
  

feedbackData.map((item, index) => {
      if(item.key === record.key) {
        console.log(item);
        setRecord(record);
      }
})

    setisfeedbackOpen(true);
  };
  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus();
    }
  };

  useEffect(() => { 
    getAllFeedback().then((res) => {
      console.log(res);

     const resultedData =  res.map((item, index) => {
        return {
          key: index + 1,
          user: item.name || "N/A",
          comment: item.description || "N/A",
          rating:  "N/A",
          date: extractDateFromISO(item.submittedAt) || "N/A",
        }
      });

      setFeedbackData(resultedData);
    }).catch((err) => {
      console.log(err);
    });
  }, []);

  const data = [
    {
      key: "1",
      user: "Tadashi Sung",
      email: "tadashisung@gmail.com",
      comment: "Apollo is a very amazing case organizer...",
      rating: 5,
      date: "10/15/2024",
    },
    {
      key: "2",
      user: "John Woodly",
      email: "tadashisung@gmail.com",
      comment: "Apollo is a very amazing case organizer...",
      rating: 5,
      date: "10/15/2024",
    },
    {
      key: "3",
      user: "Woodly John",
      email: "tadashisung@gmail.com",
      comment: "Apollo is a very amazing case organizer...",
      rating: 3,
      date: "10/15/2024",
    },
    {
      key: "1",
      user: "Tadashi Sung",
      email: "tadashisung@gmail.com",
      comment: "Apollo is a very amazing case organizer...",
      rating: 5,
      date: "10/15/2024",
    },
    {
      key: "2",
      user: "John Woodly",
      email: "tadashisung@gmail.com",
      comment: "Apollo is a very amazing case organizer...",
      rating: 5,
      date: "10/15/2024",
    },
    {
      key: "3",
      user: "Woodly John",
      email: "tadashisung@gmail.com",
      comment: "Apollo is a very amazing case organizer...",
      rating: 3,
      date: "10/15/2024",
    },
  ];

  const columns = [
    {
      title: t("adminDashboard.ratingReviews.user"),
      dataIndex: "user",
      key: "user",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.ratingReviews.comment"),
      dataIndex: "comment",
      key: "comment",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    // {
    //   title: t("adminDashboard.ratingReviews.rating"),
    //   dataIndex: "rating",
    //   key: "rating",
    //   render: (rating) => (
    //     <div className="flex gap-[2px]">
    //       {Array.from({ length: 5 }, (_, index) => (
    //         <Icon
    //           key={index}
    //           icon="ant-design:star-filled"
    //           color={index < rating ? "#FFD700" : "#D3D3D3"}
    //           width={20}
    //           height={20}
    //         />
    //       ))}
    //     </div>
    //   ),
    // },
    {
      title: t("adminDashboard.ratingReviews.date"),
      dataIndex: "date",
      key: "date",
      render: (text) => <span className="text-[#000] font-medium">{text}</span>,
    },
    {
      title: t("adminDashboard.ratingReviews.actions"),
      key: "actions",
      render: (_, record) => (
        <div className="flex gap-[8px] items-center">
          <img
            src="../../assets/icons/eye.png"
            alt="View"
            className="cursor-pointer w-[34px] h-[34px]"
            onClick={()=> onviewClick(record)}
          />
          {/* <img
            src="../../assets/icons/del.png"
            alt="Delete"
            className="cursor-pointer w-[34px] h-[34px]"
            onClick={onDelClick}
          /> */}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="files-main py-[43px] flex flex-col gap-[22px]">
        <div className="top flex items-center justify-between ">
          <h5 className="text-blue font-bold">
            {t("adminDashboard.ratingReviews.title")}
          </h5>
        </div>
        <div className="bottom">
          <div className="filter-div bg-white rounded-t-[20px] max-sm:gap-[10px] gap-[20px] flex items-center justify-between max-sm:flex-col max-sm:justify-center py-[22px] pr-[20px] pl-[15px]">
            <div className="left-div gap-[20px] flex items-center max-sm:gap-[10px]">
              <Icon
                icon="solar:filter-bold-duotone"
                color="#143A62"
                width={22}
                height={22}
              />
              <div className="flex gap-[8px] items-center">
                <p className="small font-medium">
                  {t("adminDashboard.ratingReviews.date")}:
                </p>
                <div className="flex items-center gap-[10px] rounded-[10px] p-[10px] border-[var(--stroke-weight-1,1px)]  bg-[#F0F0F0]">
                  <DatePicker
                    selected={selectedDate}
                    onChange={handleDateChange}
                    className="text-[#8D8D8D] bg-transparent font-medium small font-montserrat"
                    dateFormat="MM/dd/yyyy"
                    ref={datePickerRef} // Assign the ref to DatePicker
                  />
                  <Icon
                    icon="clarity:date-line"
                    className="text-gray-500 cursor-pointer"
                    onClick={handleIconClick} // Trigger DatePicker on icon click
                  />
                </div>
              </div>
            </div>
            <div className="py-[15px] flex items-center gap-[5px] border-b border-solid border-b-[#B8C0CB]">
              <input
                type="search"
                name=""
                id=""
                placeholder={t("adminDashboard.ratingReviews.search")}
              />
              <Icon
                icon="si:search-line"
                color="#143A62"
                width={22}
                height={22}
              />
            </div>
          </div>
          <Table
            columns={columns}
            dataSource={feedbackData}
            pagination={{
              position: ["bottomCenter"],
              pageSize: 6,
              itemRender: (current, type, originalElement) => {
                if (type === "prev") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-left-bold" color="#143A62" />
                    </div>
                  );
                }
                if (type === "next") {
                  return (
                    <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                      <Icon icon="ep:arrow-right-bold" color="#143A62" />
                    </div>
                  );
                }
                return originalElement;
              },
              showSizeChanger: false,
            }}
            className="w-full admin-dashboardTables"
            scroll={{ x: "1000px" }}
          />
        </div>
      </div>

      <DelTableRowModal isdelModalOpen={isdelModalOpen} setIsdelModalOpen={setIsdelModalOpen} />
      <RatingModal isfeedbackOpen={isfeedbackOpen} setisfeedbackOpen={setisfeedbackOpen} feedbackData={feedbackData} record={record} />

    </>
  );
};

export default RatingandReviews;
